import React from 'react'
import { Label } from 'reactstrap'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { default as Filters } from './filter'
import { useStyles } from './tabItem.css'

export const TabItem = ({ tabs, index, localize, availableColumns, page }) => {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)
  const handleExpandChange = React.useCallback((_, newExpanded) => setExpanded(newExpanded), [setExpanded])

  const id = (index >= tabs.length ? 0 : tabs[index].id)
  return (
    <div className={classes.root}>
      <Accordion expanded={id === 0 || expanded} onChange={handleExpandChange}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.summary}
          aria-controls={`panel-content_${id}`}
          id={`panel-header_${id}`}
        >
          <Label>{localize('filters.title')}</Label>
        </AccordionSummary>
        <AccordionDetails>
          <Filters id={id} availableColumns={availableColumns} page={page} />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
